import type { MailboxInfo } from "owa-client-types";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { isEnabledForFrontierCopilotAudience } from "./isEnabledForFrontierCopilotAudience";

export function isDirectiveSettingsPromptsEnabled(mailboxInfo: MailboxInfo | undefined): boolean {
    return (isGlobalFeatureEnabled("cal-ai-directiveSettings-prompts") ||
        isDirectiveSettingsPromptsFrontierEnabled(mailboxInfo));
}

export function isDirectiveSettingsPromptsFrontierEnabled(mailboxInfo: MailboxInfo | undefined): boolean {
    if (!mailboxInfo) {
        return false;
    }
    
    return isEnabledForFrontierCopilotAudience(mailboxInfo, {
        publicFlight: "cal-ai-directiveSettings-prompts-frontier-public",
        privateTapFlight: "cal-ai-directiveSettings-prompts-frontier-private-tap",
        privateStagingFlight: "cal-ai-directiveSettings-prompts-frontier-private-staging",
        privateInfluencerFlight: "cal-ai-directiveSettings-prompts-frontier-private-influencer",
    });
}
